import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let classesPromise;

export function useGstClasses() {
  const [classes, setClasses] = useState([]);
  useEffect(() => {
    classesPromise = classesPromise || axios.get(`${API}/gst/classes`).then(r => r.data);
    classesPromise.then(setClasses).catch(() => { classesPromise = null; });
  }, []);
  return classes;
}

const codeOf = (c) => c ? (c.hsn ? `HSN ${c.hsn}` : `SAC ${c.sac}`) : "";

export function GstClassConfirm({ jobClass, value, reason, onChange }) {
  const classes = useGstClasses();
  const [editing, setEditing] = useState(!!value);
  const current = classes.find(c => c.id === (value || jobClass));
  if (!classes.length) return null;
  return (
    <div data-testid="bid-gst-class" style={{ gridColumn: "1 / -1", background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: 8, padding: "10px 12px", fontSize: 12.5, textTransform: "none", letterSpacing: 0, fontWeight: 500 }}>
      <span>GST class: <b data-testid="bid-gst-class-current">{current?.label} · {current?.rate_pct}%</b> <span style={{ color: "#64748b" }}>({codeOf(current)})</span></span>
      {!editing ? (
        <button type="button" data-testid="bid-gst-class-change" onClick={() => setEditing(true)} style={{ marginLeft: 8, color: "#1d4ed8", background: "none", border: 0, cursor: "pointer", fontWeight: 700 }}>Change?</button>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 8, marginTop: 8 }}>
          <select data-testid="bid-gst-class-select" value={value || jobClass} onChange={e => onChange(e.target.value === jobClass ? null : e.target.value, reason)}>
            {classes.filter(c => c.id !== "unclassified" || c.id === jobClass).map(c => (
              <option key={c.id} value={c.id}>{c.id === jobClass ? "Keep: " : ""}{c.label} ({c.rate_pct}%)</option>
            ))}
          </select>
          <input data-testid="bid-gst-class-reason" placeholder="Reason (e.g. this is a printed carton, not a brochure)" value={reason} onChange={e => onChange(value, e.target.value)} required={!!value} maxLength={300} />
          <small style={{ gridColumn: "1 / -1", color: "#64748b" }}>If your bid wins, the buyer pays GST at this class. GoPrintPack reviews every change.</small>
        </div>
      )}
    </div>
  );
}

export function AdminGstReview({ job: initial, refresh }) {
  const classes = useGstClasses();
  const [job, setJob] = useState(initial);
  const [cls, setCls] = useState(job.gst_class || "unclassified");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const locked = ["awarded", "dispatched", "completed"].includes(job.status);
  const save = async () => {
    setBusy(true); setErr("");
    try {
      const r = await axios.patch(`${API}/admin/jobs/${job.id}/gst-class`, { gst_class: cls });
      setJob(r.data);
      toast.success("GST class reviewed");
      await refresh?.();
    } catch (e) { setErr(e.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  return (
    <div data-testid="admin-gst-review" style={{ border: `1px solid ${job.gst_review_flag ? "#FCA5A5" : "#E2E8F0"}`, background: job.gst_review_flag ? "#FEF2F2" : "#F8FAFC", borderRadius: 10, padding: "12px 14px", margin: "12px 0", fontSize: 13 }}>
      <b>GST class {job.gst_review_flag && <span data-testid="admin-gst-flag" style={{ color: "#B91C1C" }}>· needs check</span>}</b>
      {job.gst_review_reason && <div style={{ color: "#7F1D1D", fontSize: 12, margin: "4px 0" }}>{job.gst_review_reason}</div>}
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 6, flexWrap: "wrap" }}>
        <select data-testid="admin-gst-select" value={cls} disabled={locked} onChange={e => setCls(e.target.value)} style={{ padding: 6 }}>
          {classes.map(c => <option key={c.id} value={c.id}>{c.label} · {c.rate_pct}% · {codeOf(c)}</option>)}
        </select>
        <button data-testid="admin-gst-save" className="secondary-btn" disabled={busy} onClick={save}>{locked ? "Mark reviewed" : "Save & clear flag"}</button>
        <span style={{ fontSize: 11, color: "#64748b" }}>Source: {job.gst_class_source || "legacy"}{locked ? " · locked at award" : ""}</span>
      </div>
      {err && <div style={{ color: "#B91C1C", fontSize: 12, marginTop: 4 }}>{err}</div>}
    </div>
  );
}
